import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  SuccessButton,
  SuccessButtonGroup,
  SuccessButtonStatus,
} from '@rd/types';
import { ButtonModule } from '../../components/button/button.module';

@Component({
  selector: 'rd-shared-success-buttons',
  standalone: true,
  imports: [CommonModule, ButtonModule, TranslateModule],
  templateUrl: './success-buttons.component.html',
  styleUrls: ['./success-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedSuccessButtonsComponent {
  @HostBinding('class.rd-shared-success-buttons') componentClass = true;
  @Input() status: SuccessButtonStatus;
  @Input() successButtons: SuccessButtonGroup;

  successButtonClass(buttonClass: SuccessButton['buttonClass']): string {
    return `buttons ${buttonClass}`;
  }
}
